export enum FieldNames {
	FIRST_NAME = 'first_name',
	PHONE = 'phone',
	INN = 'inn',
	PASSPORT_SERIES = 'passport_series',
	PASSPORT_NUMBER = 'passport_number',
	PASSPORT_GIVEN_DATE = 'passport_given_date',
	BIRTH_DATE = 'birth_date',
	COMPANY_NAME = 'company_name',
	LAST_NAME = 'last_name',
	MIDDLE_NAME = 'middle_name',
}

export enum FieldNamesPartnerForm {
	FULL_NAME = 'full_name',
	PHONE = 'phone',
	VAT_NUMBER = 'vat_number',
	BUSINESS_NAME = 'business_name',
	CITY_ID = 'city_id',
}

export const FieldNamesPartnerFormText = {
	[FieldNamesPartnerForm.FULL_NAME]: 'Фамилия, имя*',
	[FieldNamesPartnerForm.PHONE]: 'Номер мобильного телефона*',
	[FieldNamesPartnerForm.VAT_NUMBER]: 'ИНН компании*',
	[FieldNamesPartnerForm.BUSINESS_NAME]: 'Название компании или ИП*',
	[FieldNamesPartnerForm.CITY_ID]: 'В каком городе вы ведёте бизнес?*',
}
